// extracted by mini-css-extract-plugin
export var alertContainer = "actions-module--alertContainer--ede52";
export var cartTotalsBadge = "actions-module--cartTotalsBadge--ccc6c";
export var instructionText = "actions-module--instructionText--13eee";
export var itemSelectionTable = "actions-module--itemSelectionTable--8a62c";
export var itemSelectionTableContainer = "actions-module--itemSelectionTableContainer--f0198";
export var itemSelectionTableTopSection = "actions-module--itemSelectionTableTopSection--19c4e";
export var itemTableHeader = "actions-module--itemTableHeader--60111";
export var tableSection = "actions-module--tableSection--ab9bb";